import { createColumnHelper } from '@tanstack/react-table';

import { renderEllipsisText } from '@/components/data-table/cells';
import i18n from '@/core/i18n';
import { cn } from '@/lib/utils';
import {
  ClientErrorField,
  CsvImportClientError,
} from '@/modules/onboarding/clients-setup/types/response/csv-import-clients-error.response';

const columnHelper = createColumnHelper<CsvImportClientError>();

export const getErrorClientsColumns = () => [
  columnHelper.accessor('name', {
    header: i18n.t('authenticated.onboarding.clients:importClients.name'),
    cell: ({ row, getValue }) => {
      const hasError = row.original.errorFields?.includes(ClientErrorField.NAME);
      return renderEllipsisText({
        defaultValue: i18n.t('authenticated.onboarding.clients:importClients.emptyValue'),
        className: cn(hasError && 'text-destructive'),
      })({ getValue });
    },
  }),
];
